// OVL-TOAST (ux/11 §4.2): плашка над навигацией, 3 с, до 2 строк, одна необязательная кнопка.
// Одновременно одна; новая заменяет старую. Тост ошибки — с notificationOccurred('error').
import { signal } from '@preact/signals';

export interface Toast { id: number; text: string; kind: 'info' | 'error' | 'success'; action?: { text: string; onClick: () => void } }

export const toast = signal<Toast | null>(null);
let seq = 0;
let timer: ReturnType<typeof setTimeout> | null = null;
export const TOAST_MS = 3000;

export function showToast(text: string, kind: Toast['kind'] = 'info', action?: Toast['action']): Toast {
  if (timer) clearTimeout(timer);
  const t: Toast = { id: ++seq, text, kind, ...(action ? { action } : {}) };
  toast.value = t;
  timer = setTimeout(() => { if (toast.value?.id === t.id) toast.value = null; }, TOAST_MS);
  return t;
}

export function hideToast(): void { toast.value = null; }
